import React, { useState } from 'react'
import {Dropdown, ListGroup, Modal} from 'react-bootstrap'
import {
  IVacancyCompany,
  VacancyCompanyHook
} from "../../../api/vacancy-company/vacancy-company.api";
import SignEmployee from "../SignEmployee";
import Image from "../../Partners/Image";
import {IPartner} from "../../../types/partners/IPartner";
import CreateEmployee from "../EmployeeOperations/CreateEmployee";
import {SelectField} from "../../../components/select";
import ManageRoles from "../EmployeeOperations/ManageRoles";
import UnAssignUser from "./un-assign-user";

type Props = {
  partner: IPartner
}

export const UsersVacancyCompany = ({partner}: Props) => {

  const {data: vacancyCompanyList, isLoading, refetch: VacancyCompanyRefetch} = VacancyCompanyHook.useVacancyCompanies(partner.id)

  const [selectedVacancyCompany, setSelectedVacancyCompany] = useState<IVacancyCompany | null>(null);
  const { data: list = [], refetch: UsersRefetch } = VacancyCompanyHook.useAllUsers(Number(selectedVacancyCompany))

  const { mutate: assignMutate } = VacancyCompanyHook.useAssignEmployee()

  const handleSelect = async (key: string, value: any) => {
    setSelectedVacancyCompany(value)
    await UsersRefetch()
  }

  const vacancyCompanyResponse: { id: number; name: string }[] =
    vacancyCompanyList && vacancyCompanyList[0]?.map(({ id, name }) => ({
      id: Number(id),
      name
    })) || [];


  return(
    <>
      <SelectField
        label={"Заказчик"}
        name={'companyVacancy'}
        value={selectedVacancyCompany?.name}
        onChange={handleSelect}
        options={vacancyCompanyResponse}
        />
      {selectedVacancyCompany
      ? (
       <>
         <div className="d-flex mb-3" style={{gap:20}}>
           <SignEmployee handleAssign={assignMutate} id={partner.id} update={UsersRefetch} vacancyCompanyId={Number(selectedVacancyCompany)}/>
           <CreateEmployee isPartner={false} id={partner.id} update={UsersRefetch}/>
         </div>

         <table className='table table-bordered'>
           <thead>
           <tr>
             <th>#</th>
             <th>Фото</th>
             <th>Имя</th>
             <th>Почта</th>
             <th>Роли</th>
             <th>Операции</th>
           </tr>
           </thead>
           <tbody>
           {
             list?.map((item) => {
               return (
                 <tr key={item.id}>
                   <td>{item.id}</td>
                   <td><Image path={item.photo} /></td>
                   <td>{item.fullName}</td>
                   <td>{item.email}</td>
                   <td><ListGroup>
                     {
                       item.roles.map((role, index) => {
                         return <ListGroup.Item key={index}>{role}</ListGroup.Item>
                       })
                     }
                   </ListGroup></td>
                   <td>
                     <Dropdown>
                       <Dropdown.Toggle variant="primary" id="dropdown-basic">
                         <i className="fa-solid fa-ellipsis-vertical"></i>
                       </Dropdown.Toggle>

                       <Dropdown.Menu>
                         <ManageRoles employee={item} update={UsersRefetch} />
                         <UnAssignUser companyId={partner.id} employee={item} update={UsersRefetch} id={partner.id}/>
                       </Dropdown.Menu>
                     </Dropdown>
                   </td>
                 </tr>
               )
             })
           }
           </tbody>
         </table>
       </>
      )
      : <div>Выберите заказчика</div>
      }
    </>
    )
}